// extracted by mini-css-extract-plugin
export default {"app":"home_app__pdZSH","header":"home_header__g0r0E","body":"home_body__kP2Je","bodyContent":"home_bodyContent__GbKhU"};